<div
  [ngClass]="theme() === 'dark' ? 'bg-dark-section' : 'bg-white'"
  class="flex min-w-full w-max shadow-md z-10 rounded-md p-2 px-4 gap-4"
>
  <div class="flex flex-col h-full gap-2">
    <p
      (click)="toggleAMPM(false)"
      [attr.data-theme]="theme()"
      [ngClass]="
        !isPM() ? 'bg-primary text-white' : 'hover:bg-neutral-100 theme-text'
      "
      class="p-3 px-5 text-sm transition-colors cursor-pointer rounded"
    >
      오전
    </p>
    <p
      (click)="toggleAMPM(true)"
      [attr.data-theme]="theme()"
      [ngClass]="
        isPM() ? 'bg-primary text-white' : 'hover:bg-neutral-100 theme-text'
      "
      class="p-3 px-5 text-sm transition-colors cursor-pointer rounded"
    >
      오후
    </p>
  </div>
  <div
    #hoursRef
    [attr.data-theme]="theme()"
    class="flex-1 pl-4 picker theme-border border-l border-neutral-100 max-h-[20rem] overflow-y-auto overflow-hidden"
  >
    <div class="flex flex-col h-full gap-2">
      @for (hour of hours(); track $index) {
        <p
          (click)="selectHour(hour)"
          [attr.data-theme]="theme()"
          [id]="'hour-' + hour"
          [ngClass]="
            isSameHour(hour)
              ? 'bg-primary text-white'
              : 'hover:bg-neutral-100 theme-text'
          "
          class="min-w-[7rem] w-full text-center p-3 text-sm transition-colors cursor-pointer rounded"
        >
          {{ hour }}
        </p>
      }
    </div>
  </div>
  <div
    #minutesRef
    [attr.data-theme]="theme()"
    class="flex-1 pl-4 picker theme-border border-l border-neutral-100 max-h-[20rem] overflow-y-auto overflow-hidden"
  >
    <div class="flex flex-col h-full gap-2">
      @for (minute of minutes(); track $index) {
        <p
          (click)="selectMinute(minute)"
          [attr.data-theme]="theme()"
          [id]="'minute-' + minute"
          [ngClass]="
            minute === currentMinute()
              ? 'bg-primary text-white'
              : 'hover:bg-neutral-100 theme-text'
          "
          class="min-w-[7rem] w-full text-center p-3 text-sm transition-colors cursor-pointer rounded"
        >
          {{ minute }}
        </p>
      }
    </div>
  </div>
</div>
